// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmsidebar-inline-1 {
  object-fit: contain;
  background: #fff;
}

.pmsidebar-inline-2 {
  color: #fff;
  font-family: 'Outfit',sans-serif;
  font-weight: 700;
  font-size: 15px;
}

.pmsidebar-inline-3 {
  color: #94a3b8;
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.pmsidebar-inline-7 {
  background: #2563eb;
}

.pmsidebar-inline-12 {
  background: #2563eb;
}

.pmsidebar-inline-20 {
  background: #3b82f6;
}

.pmsidebar-inline-23 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
}

.pmsidebar-inline-24 {
  flex: 1 1;
}

.pmsidebar-inline-25 {
  color: #e2e8f0;
  font-size: 12px;
  font-weight: 600;
}

.pmsidebar-inline-26 {
  color: #94a3b8;
  font-size: 10px;
}

.pmsidebar-inline-27 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  color: rgba(239,68,68,.8);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
  margin-top: 4px;
  font-family: inherit;
}

.pmsidebar-dyn-1 {
  cursor: pointer;
}

.pmsidebar-dyn-2 {
  cursor: pointer;
}

.pmsidebar-dyn-3 {
  cursor: pointer;
}

.pmsidebar-dyn-4 {
  cursor: pointer;
}

.pmsidebar-dyn-5 {
  cursor: pointer;
}

.pmsidebar-dyn-6 {
  cursor: pointer;
}

.pmsidebar-dyn-7 {
  cursor: pointer;
}

.pmsidebar-dyn-8 {
  cursor: pointer;
}

.pmsidebar-dyn-9 {
  cursor: pointer;
}

.pmsidebar-dyn-10 {
  cursor: pointer;
}

.pmsidebar-dyn-11 {
  cursor: pointer;
}

.pmsidebar-dyn-12 {
  cursor: pointer;
}

.pmsidebar-dyn-13 {
  cursor: pointer;
}

.pmsidebar-dyn-14 {
  cursor: pointer;
}

.pmsidebar-dyn-15 {
  cursor: pointer;
}

.pmsidebar-dyn-16 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMSidebar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".pmsidebar-inline-1 {\n  object-fit: contain;\n  background: #fff;\n}\n\n.pmsidebar-inline-2 {\n  color: #fff;\n  font-family: 'Outfit',sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.pmsidebar-inline-3 {\n  color: #94a3b8;\n  font-size: 9.5px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.pmsidebar-inline-7 {\n  background: #2563eb;\n}\n\n.pmsidebar-inline-12 {\n  background: #2563eb;\n}\n\n.pmsidebar-inline-20 {\n  background: #3b82f6;\n}\n\n.pmsidebar-inline-23 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n}\n\n.pmsidebar-inline-24 {\n  flex: 1;\n}\n\n.pmsidebar-inline-25 {\n  color: #e2e8f0;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pmsidebar-inline-26 {\n  color: #94a3b8;\n  font-size: 10px;\n}\n\n.pmsidebar-inline-27 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  color: rgba(239,68,68,.8);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  width: 100%;\n  margin-top: 4px;\n  font-family: inherit;\n}\n\n.pmsidebar-dyn-1 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-2 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-3 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-4 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-5 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-6 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-7 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-8 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-9 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-10 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-11 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-12 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-13 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-14 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-15 {\n  cursor: pointer;\n}\n\n.pmsidebar-dyn-16 {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
